<div class="flex flex-column align-items-center gap-3 p-4">
    @if (showEasterEgg) {
    <img src="assets/images/easter-egg.png" alt="" class="order-success-image" />
    } @else {
    <i class="pi pi-check-circle text-5xl" [style.color]="'var(--p-green-500)'"></i>
    }

    <h3 class="text-xl font-semibold m-0 text-center">{{ titleKey | translate }}</h3>
    <p class="text-secondary text-center m-0">{{ messageKey | translate }}</p>

    @if (showEasterEgg) {
    <p class="text-lg m-0 text-center">{{ 'EFFECTS_DIALOGS.EASTER_GREETING' | translate }}</p>
    }

    @if (orderNumber) {
    <p class="font-semibold m-0" style="white-space: pre-line">{{ orderNumber }}</p>
    }

    <div class="mt-2">
        <p-button [label]="'CLOSE' | translate" (onClick)="ref.close()" />
    </div>
</div>